import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { SERVICE_ICONS } from "@/lib/data";

export default function ServicesGrid({ services }) {
  return (
    <section id="services" className="bg-[#070b12] text-[#f0f4f8] py-24 md:py-32 border-b border-[#1e9bff]/15" data-testid="services-section">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6">
          <div>
            <span className="text-xs font-mono-lbl uppercase tracking-[0.2em] text-[#1e9bff] block mb-2">Our Capabilities</span>
            <h2 className="font-display uppercase text-white text-[clamp(32px,4vw,52px)] leading-none">
              Specialist Exterior Services
            </h2>
          </div>
          <p className="text-sm text-[#93b4d4] max-w-sm">
            Commercial-grade rotary washers, pure water reach systems and biocidal treatments across South Yorkshire.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <motion.article
              key={s.slug}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              className="p-6 rounded-2xl bg-[#0b1322] border border-[#1e9bff]/20 hover:border-[#1e9bff] hover:sy-glow-card transition-colors group flex flex-col justify-between"
              data-testid={`service-card-${s.slug}`}
            >
              <div>
                <div className="w-12 h-12 rounded-xl bg-[#1e9bff]/10 border border-[#1e9bff]/40 flex items-center justify-center text-[#1e9bff] mb-6 group-hover:scale-110 transition-transform">
                  <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d={SERVICE_ICONS[s.icon] || SERVICE_ICONS.house} strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <h3 className="font-display uppercase text-2xl text-white mb-2">{s.name}</h3>
                <p className="text-sm text-[#93b4d4] mb-4">{s.tagline}</p>
                <p className="text-xs font-mono-lbl text-[#1e9bff] mb-6">Includes: {s.includes}</p>
              </div>
              <Link
                to={`/services/${s.slug}`}
                data-testid={`service-card-link-${s.slug}`}
                className="inline-flex items-center justify-between text-xs font-mono-lbl uppercase tracking-wider text-white pt-4 border-t border-white/10 group-hover:text-[#1e9bff] transition-colors"
              >
                <span>Book This Service</span>
                <span className="group-hover:translate-x-1 transition-transform">→</span>
              </Link>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
